module.exports = __webpack_public_path__ + "static/bottom-54fdf9cabc0ad4f8338935b7e663c229.png";